import { getFlocktoryWindow } from './types';

export const reInitFlocktory = (): void => {
  const { flocktory } = getFlocktoryWindow();

  if (typeof flocktory?.reInit === 'function') {
    flocktory.reInit();
  }
};
